import { Column } from 'hooks/useMuiTableBuilderV2';

export const COLUMNS = {
  CHECKBOX: 'checkbox',
  EXPAND: 'expand',
  TENANT: 'tenant',
  REALM: 'realmId',
  TEAM_ID: 'teamId',
  EMAIL: 'email',
  NAME: 'name',
  STATUS: 'status',
  IMPERSONATE: 'impersonate',
  UUID: 'id',
  LAST_BACKFILLED: 'lastBackfilled',
} as const;

const checkboxColumn: Column = {
  id: COLUMNS.CHECKBOX,
  label: '',
  sortDisabled: true,
};

const tenantColumn: Column = {
  id: COLUMNS.TENANT,
  label: 'Tenant',
  sortDisabled: true,
};

const realmColumn: Column = {
  id: COLUMNS.REALM,
  label: 'Realm',
  sortDisabled: true,
};

const teamIdColumn: Column = {
  id: COLUMNS.TEAM_ID,
  label: 'Team ID',
};

const emailColumn: Column = {
  id: COLUMNS.EMAIL,
  label: 'Email',
};

const nameColumn: Column = {
  id: COLUMNS.NAME,
  label: 'Name',
  sortDisabled: true,
};

const statusColumn: Column = {
  id: COLUMNS.STATUS,
  label: 'Status',
  sortDisabled: true,
};

const impersonateColumn: Column = {
  id: COLUMNS.IMPERSONATE,
  label: 'Impersonate',
  sortDisabled: true,
};

const expandColumn: Column = {
  id: COLUMNS.EXPAND,
  label: '',
  sortDisabled: true,
};

const uuidColumn: Column = {
  id: COLUMNS.UUID,
  label: 'UUID',
  sortDisabled: true,
};

const lastBackfilledColumn: Column = {
  id: COLUMNS.LAST_BACKFILLED,
  label: 'Last Backfilled',
};

export const columns: Column[] = [
  checkboxColumn,
  expandColumn,
  statusColumn,
  impersonateColumn,
  nameColumn,
  emailColumn,
  teamIdColumn,
  tenantColumn,
  realmColumn,
];
